import { studentDataStore } from '~/store/studentData/studentDataStore';

export function useActiveStudentContext() {
  const activePeriod = studentDataStore((s) => s.activePeriod);
  const student = studentDataStore((s) => s.selectedStudent);
  return {
    student,
    studentId: student?.id ?? '',
    activePeriod,
    periodId: activePeriod?.id ?? '',
    periodCreatedAt: activePeriod?.createdAt ?? '',
  };
}
